import { gql } from 'apollo-boost'

export const UPDATE_OPERATOR_STAUS = gql`
  mutation updateOperatorStatus($data: updateOperatorStatus) {
    updateOperatorStatus(data: $data)
  }
`

